export const GET_DELIVERY_RATES = "GET_DELIVERY_RATES";
export const GET_DELIVERY_RATES_ERR = "GET_DELIVERY_RATES_ERR";
export const SET_DELIVERY_RATES = "SET_DELIVERY_RATES"; 